import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {Store} from '@ngrx/store';
import {AuthConfigService} from '../services/auth-config.service';
import {authenticate} from '../state/auth.actions';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const authConfigService = inject(AuthConfigService);

  if (authConfigService.isTokenValid()) {
    return true;
  }
  store.dispatch(authenticate());
  return false;
};
